(() => {
  const SELECTOR = '[data-image-gallery-autoscroll]';

  function initializeAutoScroll(root = document) {
    const galleries = root.querySelectorAll(SELECTOR);

    galleries.forEach((gallery) => {
      if (gallery.dataset.autoScrollInitialized === 'true') {
        return;
      }

      const originalItems = Array.from(gallery.children);

      if (originalItems.length < 2) {
        return;
      }

      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);

        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');

        clone.querySelectorAll('[id]').forEach((element) => {
          element.removeAttribute('id');
        });

        clone
          .querySelectorAll('[data-shopify-editor-block]')
          .forEach((element) => {
            element.removeAttribute('data-shopify-editor-block');
          });

        clone
          .querySelectorAll('a, button, input, select, textarea')
          .forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });

        gallery.appendChild(clone);
      });

      gallery.dataset.autoScrollInitialized = 'true';

      const updateAnimation = () => {
        const firstOriginal = gallery.children[0];
        const firstClone = gallery.children[originalItems.length];

        if (!firstOriginal || !firstClone) {
          return;
        }

        const distance =
          firstClone.offsetLeft - firstOriginal.offsetLeft;

        if (distance <= 0) {
          return;
        }

        const speed =
          Number(gallery.dataset.autoscrollSpeed) || 40;

        const duration = distance / speed;

        gallery.style.setProperty(
          '--image-gallery-marquee-distance',
          `-${distance}px`
        );

        gallery.style.setProperty(
          '--image-gallery-marquee-duration',
          `${duration}s`
        );

        gallery.classList.add('image-gallery--autoscrolling');
      };

      requestAnimationFrame(updateAnimation);

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(updateAnimation);
        resizeObserver.observe(gallery);
      }
    });
  }

  function start() {
    initializeAutoScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAutoScroll(event.target);
  });
})();